export const LOCAL_STORAGE_KEYS = {
  DISMISSED_UPDATES: 'dismissedUpdates',
  DISMISSED_PLATFORM_BANNERS: 'dismissedPlatformBanners',
  WIDGET_BUILDER: 'widgetBubble_',
  DRAFT_MESSAGES: 'draftMessages',
  COLOR_SCHEME: 'color_scheme',
  DISMISSED_LABEL_SUGGESTIONS: 'labelSuggestionsDismissed',
  MESSAGE_REPLY_TO: 'messageReplyTo',
  RECENT_SEARCHES: 'recentSearches',
  FAVORITE_WA_TEMPLATES: 'favoriteWhatsappTemplates',
  RECENT_WA_TEMPLATES: 'recentWhatsappTemplates',
  SIDEBAR_MINIMIZED_SECTIONS: 'sidebarMinimizedSections',
  CAPTAIN_OVERVIEW_V2: 'captain_overview_v2',
};
